<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Date Picker" />

    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Date Picker -->
      <div class="comm_title_wrap">
        <h3>Date Picker</h3>
      </div>        
      <button style="width:150px; height: 30px; color:white; background-color:blue; border:1px solid white" @click="onCheckDate">check 첫번째 date-picker</button>
      <div class="comm_view_wrap">                  
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              ref="firstDatePicker"
              v-model="singleDatetime"
              @confirm="onConfirm"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// day view (empty)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <fdp-validator
              v-model="singleDatetime"
              :rules="'date_format:yyyy-MM-dd'"
              name="custum"
            >
              <sui-date-picker
                v-model="singleDatetime"
                v-validate=""
                name="date_format_field"
                @confirm="onConfirm"
              />
            </fdp-validator>
          </div>
          <div class="col-xs-8">
            <span class="info">// day view (empty)(validate)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker v-model="singleDatetime1" />
          </div>
          <div class="col-xs-8">
            <span class="info">// day view (with data) 2019-10-01 &nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime1 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime1"
              disabled
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// day view (disabled) 2019-10-01 &nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime1 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime1"
              readonly
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// day view (readonly)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime1 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="weekDatetime"
              initial-view="week"
              @confirm="onConfirm"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// week view (empty)&nbsp;&nbsp;</span>
            <span class="info caution">{{ weekDatetime }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="weekDatetime1"
              initial-view="week"
              @confirm="onConfirm"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// week view (width data)&nbsp;&nbsp;</span>
            <span class="info caution">{{ weekDatetime1 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime3"
              minimum-view="year"
              initial-view="year"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// year view&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime3 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime3"
              minimum-view="year"
              initial-view="year"
              disabled
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// year view (disabled)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime3 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime3"
              minimum-view="year"
              initial-view="year"
              readonly
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// year view (readonly)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime3 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime4"
              minimum-view="month"
              initial-view="month"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// month view&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime4 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime4"
              minimum-view="month"
              initial-view="month"
              disabled
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// month view (disabled)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime4 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime4"
              minimum-view="month"
              initial-view="month"
              readonly
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// month view (readonly)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime4 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime5"
              :disabled-dates="disabledDatesTo"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// 오늘 이전으로는 선택 불가 - disabled-dates&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime5 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime8"
              :disabled-dates="disabledDatesTo1"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// 2019.08.10 이전으로는 선택 불가 - disabled-dates&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime5 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime6"
              :disabled-dates="disabledDatesFrom"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// 오늘 이후로는 선택 불가 - disabled-dates&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime6 }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime7"
              :disabled-dates="disabledDates1"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// 20190801~20190910만 선택 가능한 경우 - disabled-dates (object type) &nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime7 }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-date-picker
              v-model="singleDatetime7"
              :disabled-dates="disabledDates2"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// 08/01~09/10만 선택 가능한 경우 - disabled-dates (string)&nbsp;&nbsp;</span>
            <span class="info caution">{{ singleDatetime7 }}</span>
          </div>
        </div>
      </div>

      <!-- Range Date Picker -->
      <div class="comm_title_wrap">
        <h3>Range Date Picker</h3>
      </div>

      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-range-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              v-model="rangeDatetime"
              @confirm="onRangeChanged"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// range date picker&nbsp;&nbsp;</span>
            <span class="info caution">{{ JSON.stringify(rangeDatetime) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-range-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              v-model="rangeDatetime"
              readonly
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// range date picker (readonly)&nbsp;&nbsp;</span>
            <span class="info caution">{{ JSON.stringify(rangeDatetime) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-range-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              v-model="rangeDatetime"
              disabled
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// range date picker (disabled)&nbsp;&nbsp;</span>
            <span class="info caution">{{ JSON.stringify(rangeDatetime) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-range-date-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              v-model="rangeDatetime"
              :disabled-dates="disabledRangeDatetime"
              @confirm="onRangeChanged"
            />
          </div>
          <div class="col-xs-8">
            <span class="info">// range date picker - disabled-dates (object) &nbsp;&nbsp;</span>
            <span class="info caution">{{ JSON.stringify(rangeDatetime) }}</span><br>
          </div>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'CompGuideDatePicker',
  data() {
    return {
      singleDatetime: '2019-10-10',
      singleDatetime1: '2019-10-01',
      singleDatetime2: '2019-10-02',
      singleDatetime3: '2019',
      singleDatetime4: '2019-10',
      singleDatetime5: new Date(),
      singleDatetime6: new Date(),
      singleDatetime7: '2019-08-15',
      singleDatetime8: '2019-08-14',
      disabledDatesTo: { from: null, to: new Date() },
      disabledDatesTo1: { from: null, to: '2019-08-10' },
      disabledDatesFrom: { from: new Date(), to: null },
      disabledDates1: { from: '2019-09-10', to: '2019-08-01' },
      disabledDates2: '2019-09-10~2019-08-01',
      RangeDatetime1: '',
      RangeDatetime2: '',
      rangeDatetime: {
        from: '2019-08-05',
        to: '2019-10-07',
      },
      disabledRangeDatetime: {
        from: '2019-08-01',
        to: '2019-09-15',
      },
      disabledRangeDatetimeString: '2019-10-09~2019-10-15',
      singleDatetime2HasDateError: false,
      weekDatetime: '',
      weekDatetime1: {
        from: '2019-01-02',
        to: '2019-09-07',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    dateError() {
      this.singleDatetime2HasDateError = true;
    },
    onRangeChanged(rangeDate) {
      console.log(`\tonRangeChanged(): ${JSON.stringify(rangeDate)}`);
    },
    onConfirm(date) {
      console.log(`\tonConfirm(): ${JSON.stringify(date)}`);
    },
    onCheckDate() {
      if (this.$refs.firstDatePicker.isValid()) {
        utils.messageBox('success', '입력값이 정상입니다', null, this.positiveHandler);
      } else {
        utils.messageBox('warning', '입력값이 비정상 입니다', null, this.positiveHandler);
      }
    },    
    positiveHandler() {

    },
  },
};
</script>

<style scoped>

</style>
